/* src/app/shared/components/loaders/loader/loader.component.scss */
/*# sourceMappingURL=loader.component-2VQI25K5.css.map */
